import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import SafeIcon from '../common/SafeIcon';
import { FiArrowUp } from 'react-icons/fi';

export const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const CONTACT_URL = "https://paduaweddings.com/#contact";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 400);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {/* Sticky Mobile/Tablet CTA - Hidden on Desktop */}
      <AnimatePresence>
        {scrolled && (
          <motion.div 
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 200 }}
            className="fixed bottom-0 left-0 right-0 p-4 bg-white/80 backdrop-blur-xl border-t border-warm-stone/20 z-50 lg:hidden shadow-[0_-10px_40px_rgba(0,0,0,0.1)] flex justify-center"
          >
            <Button 
              href={CONTACT_URL} 
              variant="primary" 
              className="w-full max-w-md shadow-xl bg-olive-grove text-white font-bold"
              aria-label="Request a proposal"
            >
              Request a Proposal
            </Button>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Floating Back to Top (Desktop Only) */}
      <AnimatePresence>
        {scrolled && (
          <motion.button 
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0, opacity: 0 }}
            onClick={scrollToTop}
            className="fixed bottom-8 right-8 w-12 h-12 bg-deep-charcoal text-white rounded-full flex items-center justify-center shadow-float hover:bg-olive-grove hover:scale-110 active:scale-95 transition-all duration-300 z-50 hidden lg:flex"
            aria-label="Back to top"
          >
            <SafeIcon icon={FiArrowUp} className="w-5 h-5" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  );
};